<template>
  <div>
    <template v-if="!isGenerating">
      <pane-response-situation
          style="margin-top: 25px; margin-bottom: 25px;"
          :situation="situation"
          :is-private="isPrivate"
          :date="createdAt"
          :max-words="maxWords"
          :idx="idx"
          @page-to="handlePageTo"
        />
      <b-row>
        <b-col cols="9">
          <h2>
            <span class="half_background">
            Divine Insights: <i>God's Guidance for You</i>
            </span>
          </h2>
        </b-col>
        <b-col>
          <b-button
              size="md"
              class="float-right"
              :disabled="!output || (output && !output.audioPath)"
              @click="handlePlayPauseAudioResponse()"
              style="margin-left: 10px;background-color:#0fb6fe; color:#FFFFFF;border-radius: 10px"
          >
            <template v-if="isPlaying">
              <b-icon
                  v-if="this.audio"
                  scale="1.5"
                  icon="pause-fill"
              />
              Pause Audio
            </template>
            <template v-else>
              <b-icon
                  v-if="this.audio"
                  scale="1.5"
                  icon="pause-fill"
              />
              <b-icon
                  scale="1.5"
                  icon="play"
              />
              Play Audio
            </template>
          </b-button>
        </b-col>
      </b-row>

      <div
       style="background-color: #cbeefd;
       border-radius: 15px;
       margin-top: 25px;
       padding:20px;"
      >
        <div v-if="typeof output === 'object'">
          <b-row>
            <b-col md="6"
                style="background-color: #222222;
                color: white;
                border-radius: 25px;
                padding: 35px;
                margin-right: 5px;"
            >
              <pane-response-word-section
                  :profile="profile"
                  :curr-doc="currDoc"
                  :path="path"
                  :encouraging-words="encouragingWords"
                  :scriptures="scriptures"
                  :parting-words="partingWords"
              />
            </b-col>
            <b-col
                md="6"
                class="d-none d-sm-block d-md-none"
                style="margin-top: 25px;"
            />
            <b-col
                style="background-color: #222222;
                color: white;
                border-radius: 25px;
                padding: 25px;
                margin-left: 5px;
                position: relative
            "
            >
              <pane-response-action-items
                  :idx="idx"
                  :items="actionItems"
                  :curr-doc="currDoc"
                  :output="output"
              />
            </b-col>
          </b-row>
        </div>
        <div v-else>
          {{output}}
        </div>
      </div>
    </template>
    <template v-else>
      <b-skeleton animation="throb" width="85%"></b-skeleton>
      <b-skeleton animation="throb" width="55%"></b-skeleton>
      <b-skeleton animation="throb" width="70%"></b-skeleton>
      <b-skeleton animation="throb" width="85%"></b-skeleton>
      <b-skeleton animation="throb" width="55%"></b-skeleton>
      <b-skeleton animation="throb" width="70%"></b-skeleton>
    </template>
  </div>
</template>

<script>
import firebase from "firebase";
import PaneResponseWordSection from "./paneResponseWordsSection";
import PaneResponseActionItems from "./paneResponseActionItems";
import PaneResponseSituation from "./paneResponseSituation";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
export default {
  name: "Display_PaneResponse",
  mixins: [ResourceBlockDisplay],
  components: {
    PaneResponseWordSection,
    PaneResponseActionItems,
    PaneResponseSituation
  },
  created(){},
  mounted() {},
  props: {
    currDoc: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
    path: {
      type: String,
      required: false,
      default: ''
    },
    profile: {
      type: Object,
      required: false,
      default: () => {}
    },
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    maxWords: {
      type: Number,
      required: true,
      default: 0
    },
    isGenerating: {
      type: Boolean,
      required: true,
      default: false
    },
    output: {
      type: [Object, String],
      required: false,
      default: () => {}
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    situation(){
      return this.currDoc && this.currDoc.situation ? this.currDoc.situation : null;
    },
    createdAt(){
      return this.currDoc && this.currDoc._created_at ? this.currDoc._created_at : null;
    },
    encouragingWords(){
      return this.output && this.output.encouraging_words ? this.output.encouraging_words : null;
    },
    scriptures(){
      return this.output && this.output.scriptures ? this.output.scriptures : null;
    },
    partingWords(){
      return this.output && this.output.parting_words ? this.output.parting_words : null;
    },
    actionItems(){
      return this.output && this.output.action_items ? this.output.action_items : null;
    },
    isPrivate(){
      return this.currDoc && this.currDoc.isPrivate ? this.currDoc.isPrivate : false;
    },
    outputAudioPath(){
      return this.output && this.output.audioPath ? this.output.audioPath : null;
    },
    canPlayAudio(){
      return !!this.outputAudioPath;
    },
    duration(){
      return this.audio && this.audio.duration?
          this.audio.duration : 0;
    },
    currentTime(){
      return this.audio && this.audio.currentTime?
          this.audio.currentTime : 0;
    },
    paused(){
      return this.audio && this.audio.paused?
          this.audio.paused : false;
    },
    isPlaying(){
      return this.isAudioPlaying;

      //return this.audio && this.audio.duration && !this.audio.paused ?
        //  this.audio.duration > 0 : false;
    }
  },
  methods: {
    handlePageTo(pageNumber){
      this.$emit('page-to', pageNumber);

      if (this.audio) {
        this.audio.pause();
        this.audio = null;
        this.isAudioPlaying = false; //Temp
      }
    },
    handlePlayPauseAudioResponse() {
      if (this.isAudioPlaying){
        //Pause It
        this.pauseAudioResponse();
      }else {
        //Play It
        this.playAudioResponse();
      }
    },
    playAudioResponse(){
      if (this.outputAudioPath) {
        // Get a reference to the text-to-speech file
        if (!this.audio) {
          const storageRef = firebase.storage().refFromURL(this.outputAudioPath);
          // Get the audio file URL
          storageRef.getDownloadURL().then(url => {
            // Create a new audio element
            this.audio = new Audio(url);
            // Play the audio file
           // let vm = this;
            this.audio.addEventListener('ended',(x)=>{
              this.isAudioPlaying = false; //Temp
            });

            this.audio.play();
            this.isAudioPlaying = true; //Temp
          });
        } else if (this.audio) {
          this.audio.play();
          this.isAudioPlaying = true; //Temp
        }
      }
    },
    pauseAudioResponse(){
      this.audio.pause();
      this.isAudioPlaying = false; //Temp
    }
  },
  data() {
    return {
      audio: null,
      isAudioPlaying: false //temp
    };
  }
};
</script>

<style lang="scss" scoped>
.half_background {
  background: linear-gradient(to top, rgb(203,238,253) 50%, transparent 50%);
}
</style>
